module.exports = __webpack_public_path__ + "static/26invgde-124ec96212b428c62282801f044a4b83.gif";